import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AdventureComponent } from "./adventure.component";
import { RouterModule } from "@angular/router";
import { AngularToastifyModule } from "angular-toastify";
import { NavbarRoutingModule } from "../navbar-routing.module";
import { SharedModule } from "src/app/shared/components/shared.module";
import { MatIconModule } from "@angular/material/icon";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { AdventureListComponent } from "./adventure-list/adventure-list.component";
import { MatTabsModule } from "@angular/material/tabs";
import { AddAdventureDialog } from "./add-adventure/add-adventure.component";
import { AdventureCustomConfigComponent } from "./add-adventure/adventure-custom-config/adventure-custom-config.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule } from "@angular/material/dialog";
import { MatStepperModule } from "@angular/material/stepper";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatExpansionModule } from "@angular/material/expansion";

@NgModule({
	imports: [
		NavbarRoutingModule,
		CommonModule,
		RouterModule,
		AngularToastifyModule,
		SharedModule,
		MatIconModule,
		MatToolbarModule,
		MatButtonModule,
		MatTabsModule,
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		MatProgressSpinnerModule,
		MatCheckboxModule,
		MatPaginatorModule,
		MatTableModule,
		MatTooltipModule,
		MatDialogModule,
		MatStepperModule,
		DragDropModule,
		FormsModule,
		ReactiveFormsModule,
		MatExpansionModule
	],
	declarations: [
		AdventureComponent,
		AdventureListComponent,
		AddAdventureDialog,
		AdventureCustomConfigComponent,
	],
})
export class AdventureModule {}
